import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import ResultsInner from './ResultsInner'

// TODO: Check `Results.js` component usage, maybe we need use subcomponents for every result group instead
@inject('categories')
@observer
class Results extends Component {
  componentWillMount () {
    this.props.categories.get()
  }

  render () {
    let {
      type,
      showCategoryLinks,
      categories,
      categoryId,
      excludeIds,
      maxCategories,
      maxCategoryExperiences
    } = this.props
    console.log('Results.js - categories', categories)

    if (!categories.loaded) {
      return (<div />)
    }

    return (
      <ResultsInner type={type}
                    showCategoryLinks={showCategoryLinks}
                    excludeIds={excludeIds}
                    categories={categories.data}
                    categoryId={categoryId}
                    maxCategories={maxCategories}
                    maxCategoryExperiences={maxCategoryExperiences} />
    )
  }
}

Results.defaultProps = {
  type: 'horizontal',
  showCategoryLinks: true
}

Results.propTypes = {
  type: PropTypes.string,
  showCategoryLinks: PropTypes.bool,
  excludeIds: PropTypes.array,
  categoryId: PropTypes.string,
  maxCategories: PropTypes.number,
  maxCategoryExperiences: PropTypes.number,
  categories: MobxPropTypes.observableObject
}

export default Results



// WEBPACK FOOTER //
// ./src/components/Results.js